import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './privacy-policy.css'; 
import Topbar from './Topbar';

export default function PrivacyPolicy() {

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  return (
    <>
      
      <Navbar />
      <section className="PrivacyPolicy">
        <h1 id="PP">Privacy Policy</h1>
        <p>Welcome to Shiva Nadi Astrology! Your trust is our utmost priority. This Privacy Policy outlines how we collect, use, protect, and manage your information to deliver astrological services worldwide.</p>

        <h2>1. Information We Collect</h2>
        <p>To provide personalized and accurate astrological services, we may collect the following information:</p>
        <ul>
          <li>Personal details: Name, date of birth, time of birth, and place of birth</li>
          <li>Contact information: Email address, phone number, and physical address</li>
          <li>Payment information: Billing details for processing transactions</li>
          <li>Technical data: IP address, browser type, and access times for website analytics</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Your information is utilized to ensure precise and tailored astrological consultations. Specifically, we may use it to:</p>
        <ul>
          <li>Prepare and deliver personalized astrology readings and services</li>
          <li>Respond to inquiries and provide customer support</li>
          <li>Enhance our services and user experience globally</li>
          <li>Send notifications, updates, and promotional materials (if opted-in)</li>
          <li>Maintain website security and monitor fraudulent activities</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>We value your privacy and do not sell or share your personal information with third parties, except:</p>
        <ul>
          <li>With trusted service providers to process payments or facilitate communication</li>
          <li>When required by law, legal processes, or governmental requests</li>
          <li>To protect our rights, users, and systems against fraudulent activities</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>We implement advanced security measures, including encryption and secure servers, to safeguard your information. However, no method of transmission over the internet is entirely secure, and we urge you to take precautions when sharing sensitive details online.</p>

        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access, update, or correct your personal data</li>
          <li>Request the deletion of your data, where applicable</li>
          <li>Withdraw consent for promotional communications at any time</li>
        </ul>
        <p>To exercise these rights, please contact us using the details below.</p>

        <h2>6. Global Compliance</h2>
        <p>As a worldwide service provider, we comply with international data protection regulations, including the GDPR (Europe), CCPA (California), and other relevant privacy laws. Your data is handled with the highest level of compliance and respect for your privacy.</p>

        <h2>7. Cookies</h2>
        <p>Our website uses cookies to enhance your browsing experience. Cookies help us understand user preferences and improve our services. You may choose to disable cookies through your browser settings, though this may limit certain functionalities of our website.</p>

        <h2>8. Updates to This Privacy Policy</h2>
        <p>We may revise this Privacy Policy periodically to reflect changes in our practices, services, or applicable laws. Updates will be published on this page, and we encourage you to review it regularly.</p>

        <h2>9. Contact Us</h2>
        <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at:</p>
        <p>Email: <a href="mailto:shivanadiastrologer@gmail.com">shivanadiastrologer@gmail.com</a></p>
        <p>Phone: +91 74021 67580</p>
        <p>Address: LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE,
Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad,
Telangana 500062.</p>
      </section>
      <Footer />
    </>
  );
}
